import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { Heading, Paragraph, Button } from 'components';
import './SectionHeader.scss';

class SectionHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isDescriptionHidden: !props.hiddenDescription,
    };
  }

  setSizeClass = type => {
    const sizes = {
      'extra-large': ['extra-large', 1, 'medium'],
      large: ['large', 1, 'medium'],
      big: ['large', 2, 'medium'],
      medium: ['big', 3, 'medium'],
      small: ['medium-plus', 3, 'regular'],
      'tiny-plus': ['medium', 3, 'regular'],
      tiny: ['small', 4, 'small'],
    };
    return sizes[type];
  };

  render() {
    const { isDescriptionHidden } = this.state;
    const {
      children,
      color,
      description,
      lineColor,
      noLine,
      descriptionColor,
      size,
      additionalClass,
      fixed,
      headingType,
      hiddenDescription,
      buttonColor,
    } = this.props;
    const lineColorClass = lineColor
      ? `section-header__headline--${lineColor}`
      : '';
    const noLineClass = noLine ? 'section-header__headline--no-line' : '';
    const headingSize = this.setSizeClass(size);

    return (
      <div
        className={`section-header section-header--${size} ${additionalClass}`}
      >
        <div
          className={`section-header__headline ${lineColorClass} ${noLineClass}`}
        >
          <Heading
            color={color}
            size={headingSize[0]}
            type={headingType || headingSize[1]}
          >
            {children}
          </Heading>
        </div>
        {description && (
          <div
            className={`section-header__description ${
              fixed ? '' : 'anim-fade-in-bottom'
            }`}
          >
            <Paragraph
              color={descriptionColor}
              size={headingSize[2]}
              additionalClass={'text--light'}
              spaced
              nested
            >
              {typeof description === 'object'
                ? description
                : ReactHtmlParser(description)}
            </Paragraph>
            {!isDescriptionHidden && (
              <Paragraph
                color={descriptionColor}
                size={headingSize[2]}
                additionalClass={'text--light'}
                spaced
              >
                {typeof hiddenDescription === 'object'
                  ? hiddenDescription
                  : ReactHtmlParser(hiddenDescription)}
              </Paragraph>
            )}
            {hiddenDescription && (
              <Button
                onClick={() =>
                  this.setState({
                    isDescriptionHidden: !isDescriptionHidden,
                  })
                }
                color={buttonColor}
                transparent
                additionalClass={'section-header__read-more'}
              >
                {!isDescriptionHidden ? 'Show less' : 'Show more'}
              </Button>
            )}
          </div>
        )}
      </div>
    );
  }
}

SectionHeader.defaultProps = {
  description: '',
  lineColor: '',
  noLine: false,
  color: '',
  additionalClass: '',
  fixed: false,
  size: 'big',
  descriptionColor: 'default',
  headingType: null,
  hiddenDescription: null,
  buttonColor: 'white',
};

SectionHeader.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  lineColor: PropTypes.string,
  noLine: PropTypes.bool,
  color: PropTypes.string,
  size: PropTypes.string,
  additionalClass: PropTypes.string,
  descriptionColor: PropTypes.string,
  fixed: PropTypes.bool,
  hiddenDescription: PropTypes.string,
  buttonColor: PropTypes.string,
  headingType: PropTypes.oneOf([null, 1, 2, 3, 4, 5, 6]),
};

export default SectionHeader;
